<template>
  <div>
    <div class="menu" id="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item> 
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="top">
        <span> Download </span>
      </div>
      <div class="search">
        <span>
          <el-input
            placeholder="Please enter the keyword you want to search"
            style="width: 350px"
            v-model="searchInput"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            style="background-color: seagreen"
            @click="btnSearch"
            >Search</el-button
          >
        </span>
      </div>
      <!--表格-->
      <div class="table">
        <el-table
          :data="tableData"
          stripe
          border
          :header-cell-style="{ textAlign: 'center' }"
          style="width: 100%"
        >
          <el-table-column prop="version" label="Version">
            <template slot-scope="scope">
              <a>{{ scope.row.version }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="genome" label="Genome">
            <template slot-scope="scope">
              <a :href="url + scope.row.versionurl + '.'+ scope.row.genome +'.fa.gz'">{{
                scope.row.genome
              }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="gff" label="GFF">
            <template slot-scope="scope">
              <a :href="url + scope.row.versionurl+ '.' + scope.row.gff+ '.fa.gz'">{{
                scope.row.gff
              }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="cds" label="CDS">
            <template slot-scope="scope">
              <a :href="url + scope.row.versionurl + '.'+ scope.row.cds + '.fa.gz'">{{
                scope.row.cds
              }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="protein" label="Protein">
             <template slot-scope="scope">
              <a :href="url + scope.row.versionurl + '.'+ scope.row.protein+ '.fa.gz'">{{
                scope.row.protein
              }}</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var path = require('path');
var proEnv = require('../../../config/pro.env');//生产环境
var uatEnv = require('../../../config/uat.env');//测试环境
var devEnv = require('../../../config/dev.env');//本地环境
export default {
  data() {
    return {
      searchInput: "",
      tableData: [],
      url:''
    };
  },
  created() {
    let that = this
     window.addEventListener("scroll", this.handleScroll); 
    let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
    //console.log(process.env.NODE_ENV);
    const env = process.env.NODE_ENV;
    let target = '';
    //默认是本地环境
    if (env === 'production') {//生产环境
      target = proEnv.downloadurl;
    } else if (env === 'test') {//测试环境
      target = uatEnv.downloadurl;
    } else {//本地环境
      target = devEnv.downloadurl;
    }
    this.url=target;
    this.getList("");
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
    btnSearch(){
      this.getList(this.searchInput);
    },
    getList(keyword) {
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/gooal/genome/latinName/list?keyword=" + keyword,{
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          let data = response.data.result;
          let arr = [];
          for (let i = 0; i < data.length; i++) {
            arr.push({
              version: data[i],
              versionurl: data[i].replace(/\ /g, "_"),
              genome: "Genome",
              gff: "GFF",
              cds: "CDS",
              protein: "Protein",
            });
          }
          ////console.log(arr);
          that.tableData = arr;
        })
        .catch(function (error) {
          //that.$message.error("失败!");
          //console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
td a{
  color: seagreen;
}
.content {
  width: 1200px;
  margin: 10px auto;
  overflow: auto;
  background-color: #eee;
  min-height: 555px;
}
.top {
  margin-top: 10px;
  color: seagreen;
  font-size: 24px;
  margin-left: 30px;
}
.search span {
  margin-left: 724px;
}
.table {
  width: 1160px;
  margin: 20px auto;
}
</style>>